<div class="step-content">
  <div class="report-summary">
    <p>
      <strong>{{'common.label.report-type' | translateSafe}}: </strong>
      {{ reportType || '-' }}
    </p>

    <!--<p>
      <strong>Berichtsart:</strong>
      {{ data.reportMode || '-' }}
    </p>-->

    @if (hasReportTime) {
      <p>
        <strong>{{'common.input.data-from.label' | translateSafe}}:</strong>
        {{ dateFrom }}
      </p>

      <p>
        <strong>{{'common.input.data-to.label' | translateSafe}}:</strong>
        {{ dateTo }}
      </p>
    }
    <!--@if (data.selectedLabel) {
      <p>
        <strong>{{ data.selectedLabel }}:</strong>
        {{ data.selectedCount }}
      </p>
    }

    <p>
      <strong>Ausgeblendete Spalten:</strong>
      {{ data.disabledColumns.length ? data.disabledColumns.join(', ') : '-' }}
    </p>-->

    <p>
      <strong>Format:</strong>
      {{ reportFormat || '-' }}
    </p>
  </div>
</div>
